import axios from 'axios'
import { BASE_URL, BASE_HREF } from '../config/index'
import store from '../store/index'
import { Toast, MessageBox } from 'mint-ui'
import qs from 'qs'
// 创建axios实例
const service = axios.create({
  baseURL: BASE_URL, // api的base_url
  timeout: 60000, // 请求超时时间
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    let sessionId = store.getters.sessionId
    if (sessionId) {
      const uname = 'h5'
      const ukey = '85be376d0670f10bb8a77916bf774e53'
      if (config.method === 'post') {
        config.data = qs.stringify({
          uname: uname,
          ukey: ukey,
          tokenid: sessionId,
          ...config.data
        })
      } else if (config.method === 'get') {
        config.params = {
          uname: uname,
          ukey: ukey,
          tokenid: sessionId,
          ...config.params
        }
      }
    } else {
      if (config.method === 'post') {
        config.data = qs.stringify(config.data)
      }
    }
    // 在发送请求设置cancel token
    config.cancelToken = new axios.CancelToken(cancel => {
      store.commit('pushToken', {cancelToken: cancel})
    })
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    const data = response.data
    if (data.IsError) {
      if (data.ErrCode === 301) {
        // 会话超时，正在重新进入
        store.dispatch('loginOut').then(() => {
          if (store.getters.getIsApp) {
            window.uni.postMessage({
              data: {
                'logOut': true
              }
            })
            return
          }
          let instance = Toast('会话超时，正在重新进入')
          setTimeout(() => {
            instance.close()
            window.location.href = BASE_HREF
          }, 2000)
        })
      } else if (data.ErrCode === 302) {
        // 账号被冻结，请联系客服处理
        MessageBox('提示', '账号被冻结，请联系客服处理')
      } else {
        return Promise.reject(data)
      }
    }
    return data
  },
  error => {
    if (error.message !== '路由跳转取消请求') {
      Promise.reject(error)
    }
  }
)

export default service
